import React from 'react';
import Marketplace from '@/pages/Marketplace';

const MarketplaceItemPage = () => {
  return (
    <div className="space-y-6" data-testid="marketplace-item-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Marketplace</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Listing Details</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            View details, photos, and contact the seller about this listing.
          </p>
        </div>
      </div>
      <Marketplace />
    </div>
  );
};

export default MarketplaceItemPage;
